export const sharedEnvironment = {
  apiTimeoutMs: 2000,
  mapsApiTimeoutMs: 8000,
  catalogUploadTimeoutMs: 15000,
  firebase: {
    apiKey: 'AIzaSyCNEqgen8jcModPeD9ugkkD4nXx1CSb_es',
    authDomain: 'zepbazaarmessage.firebaseapp.com',
    projectId: 'zepbazaarmessage',
    storageBucket: 'zepbazaarmessage.firebasestorage.app',
    messagingSenderId: '576066801864',
    appId: '1:576066801864:web:c198e589e7980c4da6d5fd',
    measurementId: 'G-W7CJM6M3SS',
    vapidKey:
      'BKLPwD1jX5voAZZVSgzFd16ySdaOiwlWj6JtT5SicoKZPvX6m6HzCeYh2JO3mI04OiiXXGOXiQ7XVNRM4ucbol4',
  },
};
